import { render, staticRenderFns } from "./ElderExperiencing.vue?vue&type=template&id=e3cc2d10&scoped=true&"
import script from "./ElderExperiencing.vue?vue&type=script&lang=js&"
export * from "./ElderExperiencing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cc2d10",
  null
  
)

export default component.exports